import { render } from "./AddBrand.vue?vue&type=template&id=08c13849&scoped=true"
import script from "./AddBrand.vue?vue&type=script&lang=js"
export * from "./AddBrand.vue?vue&type=script&lang=js"

import "./AddBrand.vue?vue&type=style&index=0&id=08c13849&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08c13849"]])

export default __exports__